import { render, staticRenderFns } from "./pass-list.vue?vue&type=template&id=bc2bc256&scoped=true"
import script from "./pass-list.vue?vue&type=script&lang=js"
export * from "./pass-list.vue?vue&type=script&lang=js"
import style0 from "./pass-list.vue?vue&type=style&index=0&id=bc2bc256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2bc256",
  null
  
)

export default component.exports